import { useEffect, useState } from "react";
import { loaiLienHeApi } from "../../api/loaiLienHeApi";
import { NotifyHelper } from "../../helpers/toast";

export interface ILoaiLienHeItem {
    id: number;
    ten_loai: string;
    is_active: boolean;
    co_ngay_hen: boolean;
}

// Danh sách loại liên hệ đang hoạt động của cơ sở, dùng chung cho select và các điều kiện theo cấu hình
export const useLoaiLienHe = (dm_coso_id?: number): ILoaiLienHeItem[] => {
    const [loaiLienHes, setLoaiLienHes] = useState<ILoaiLienHeItem[]>([]);

    useEffect(() => {
        if (!dm_coso_id) {
            setLoaiLienHes([]);
            return;
        }
        loaiLienHeApi.select_by_coso(dm_coso_id).then((res: any) => {
            if (!res.is_success) {
                NotifyHelper.Error(res.message || "Không tải được danh sách loại liên hệ");
                return;
            }
            setLoaiLienHes(Array.isArray(res.data) ? res.data.filter((x: ILoaiLienHeItem) => x.is_active) : []);
        });
    }, [dm_coso_id]);

    return loaiLienHes;
};
